import { Button } from "@/components/ui/button";
import { ArrowRight, BarChart3 } from "lucide-react";

export const Hero = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-gradient-hero overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-grid-pattern"></div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-10 opacity-20 animate-pulse">
        <BarChart3 size={48} className="text-accent" />
      </div>
      <div className="absolute bottom-20 right-10 opacity-20 animate-pulse delay-1000">
        <BarChart3 size={36} className="text-accent" />
      </div>

      <div className="container mx-auto px-4 lg:px-8 text-center z-10">
        <div className="max-w-4xl mx-auto animate-slide-up">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Transforme seus dados em{" "}
            <span className="text-accent">decisões poderosas</span>
          </h1>
          
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            Soluções especializadas em Power BI para impulsionar sua tomada de decisão com dashboards inteligentes e insights acionáveis
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg" 
              onClick={() => scrollToSection('contato')}
              className="bg-accent hover:bg-accent-light text-accent-foreground font-semibold px-8 py-4 text-lg group transition-all duration-300"
            >
              Fale Conosco
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => scrollToSection('servicos')}
              className="bg-white/10 border-white/30 text-white hover:bg-white/20 px-8 py-4 text-lg backdrop-blur-sm"
            >
              Nossos Serviços
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 mt-16 pt-16 border-t border-white/20">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent mb-2">100+</div>
              <div className="text-white/80">Projetos Entregues</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent mb-2">50%</div>
              <div className="text-white/80">Redução de Custos</div>
            </div>
            <div className="text-center col-span-2 md:col-span-1">
              <div className="text-3xl md:text-4xl font-bold text-accent mb-2">24/7</div>
              <div className="text-white/80">Suporte Técnico</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};